import styled from 'styled-components'

export const TextContainer = styled.p`
    display: -webkit-box;
    line-height: 12px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 11px;
    font-family: ${({ theme }) => theme['font-regular']};
    color: #000;
    margin: 0;
`

export const EscalationContainer = styled.g`
    .delete-escalation-button {
        display: none;
    }

    .delete-escalation-button.active {
        display: unset;
    }

    :hover {
        .delete-escalation-button {
            display: unset;
        }
    }
`
